<template>
    <v-dialog v-model="loginDialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Login</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                autofocus
                                v-model="loginEmail"
                                label="E-mail*"
                                outlined
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="loginPassword"
                                label="Password*"
                                outlined
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                required
                                type="password"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" v-if="loginError">
                            <v-alert type="error">
                                Email or password incorrect
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-container>
                <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="secondary"
                    @click="close"
                    v-if="showCloseButton"
                >
                    Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="login"
                >
                    Login
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from '@vue/composition-api';
import axios from 'axios';

export default defineComponent({
    name: 'LoginDialog',
    props: {
        open: {
            type:  Boolean,
        },
        showCloseButton: {
            type:  Boolean,
            default: true,
        },
    },
    emits: ['loggedIn'],
    setup(props, context) {
        const loading = ref(false);
        const loginDialog = ref(false);
        const loginEmail = ref(null);
        const loginPassword = ref(null);
        const loginError = ref(false);

        const accessToken = ref(null);
        const refreshToken = ref(null);
        const tokenExpiresAt = ref(null);
        const showPassword = ref(false);

        watch(() => props.open, (currentValue, oldValue) => {
            loginDialog.value = currentValue;
        });

        onMounted(() => {
            init();
        });

        function init() {
            if(props.accessToken !== '') {
                accessToken.value = props.accessToken;
            }
        }

        function close() {
            loginDialog.value = false;
            context.emit("closed", true);
        }

        function login() {
            loading.value = true;
            loginError.value = false;
            axios.post('password-login', {
                email: loginEmail.value,
                password: loginPassword.value
            })
            .then(function (response) {
                if(response.data.access_token) {
                    accessToken.value = response.data.access_token;
                }
                if(response.data.refresh_token) {
                    refreshToken.value = response.data.refresh_token;
                }
                if(response.data.expires_in) {
                    tokenExpiresAt.value = response.data.expires_in;
                }
                if(loginDialog.value == true) {
                    loginDialog.value = false;
                }
                saveTokensToSession(response.data);
                getProfile();
            })
            .catch(function (error) {
                console.log(error);
                loginError.value = true;
            })
            .then(function () {
                loading.value = false;
            });
        }

        function saveTokensToSession(responseData) {
            axios({
                method:'post',
                url:'save-session',
                baseURL: '/',
                data: {
                    responseData: responseData
                }
            })
            .then(function (response) {
            })
            .catch(function (error) {
            })
            .then(function () {
                loading.value = false;
            });
        }

        function getProfile() {
            let token = '';
            if(accessToken.value) {
                token = accessToken.value;
            }
            if(token !== '') {
                loading.value = true;
                axios.get('profile', {
                    headers: {
                        authorization: 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    context.emit("loggedIn", {
                        loggedInProfile: response.data,
                        accessToken: accessToken.value
                    });
                })
                .catch(function (error) {
                })
                .then(function () {
                    loading.value = false;
                });
            }
            return;
        }

        return {
            // Variables
            loading,
            loginDialog,
            loginEmail,
            loginPassword,
            loginError,
            showPassword,
            // Functions
            login,
            close,
        }

    }
});
</script>
